import { fetchApi } from 'react-scale/redux/actions';
interface TimeInfo {
  days: number;
  hours: number;
  minutes: number;
}

export const minutesToMilliseconds = (minutes: number): number => {
  return minutes * 60000; // 1 minute = 60,000 milliseconds
};

export const convertTimeDifferenceToTimeLeft = (timeDifferenceMs: number): string => {
  // Convert milliseconds to days, hours, and minutes
  const days = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDifferenceMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifferenceMs % (1000 * 60 * 60)) / (1000 * 60));

  return formatTime({ days, hours, minutes });
};

export const convertExpirationDatesToTimeLeft = (targetDateStr: string): string => {
  // Convert the target date string to a Date object
  const targetDate = new Date(targetDateStr);

  // Get the current date and time
  const currentDate = new Date();

  // Calculate the time difference in milliseconds
  const timeDifferenceMs = targetDate.getTime() - currentDate.getTime();

  // Convert milliseconds to days, hours, and minutes
  return convertTimeDifferenceToTimeLeft(timeDifferenceMs);
};

const formatTime = (timeInfo: TimeInfo): string => {
  const { days, hours, minutes } = timeInfo;
  if (days > 0) {
    return `${days} day${days !== 1 ? 's' : ''}`;
  } else if (hours > 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  } else {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
};

export const maybeStopWorkspace = async (workspaceId: string): Promise<void> => {
  try {
    await fetchApi<void>(`/genai/stopCodingWorkspace`, {
      body: {
        workspaceId,
      },
      maxRetries: 3,
      method: 'POST',
      parseAndHandle: true,
      redirectOnUnauthorized: true,
    });
  } catch {
    // Do nothing
  }
};

export const ASSIGNMENT_DETAILS_FETCH_REFRESH_TIME = 1000 * 60 * 60 * 3; // 3 hour

export const GET_CODING_WORKSPACE_FILES_REFRESH_TIME = 1000 * 60 * 60; // 1 hour
